import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const workScheduleApi = {
  findAll: (params: { month: number; year: number; staffId?: number }): AxiosPromise<any> =>
    request({
      url: "/v1/admin/work-schedule",
      params,
    }),
  create: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/work-schedule",
      data,
      method: "post",
    }),
  update: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/work-schedule/${id}`,
      method: "put",
      data,
    }),
  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/work-schedule/${id}`,
      method: "delete",
    }),
};
